// components/Footer.js
import { Container, Typography } from "@mui/material";

export default function Footer() {
  return (
    <footer>
      <Container
        maxWidth="lg"
        sx={{
          textAlign: "center",
          padding: "24px 0",
          color: "rgb(113, 128, 150)",
        }}
      >
        <Typography variant="body2">
          © {new Date().getFullYear()} <strong>Valentin-Marko</strong> –
          Software Development Blog. All rights reserved.
        </Typography>
      </Container>
    </footer>
  );
}
